import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-video',
  templateUrl: './no-video.component.html',
  styleUrls: ['./no-video.component.scss']
})
export class NoVideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
